export const routeFrom = () => {
  let route_from = JSON.parse(localStorage.getItem("route_from"));
  return route_from ? route_from : {};
};

export const routeBack = (route_name, query = {}, params = {}) => {
  let route_data = routeFrom();
  if (route_data.name != route_name) {
    route_data = {
      name: route_name,
      query: query,
      params: params,
    };
  }
  return route_data;
};

export default { routeFrom, routeBack };
